/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyPharmacistUpdatableTypename = "PharmacyPharmacistUpdatable" as const;

/**
 *
 * @export
 * @interface PharmacyPharmacistUpdatable
 */
export interface PharmacyPharmacistUpdatable {
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacistUpdatable
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacistUpdatable
   */
  lastName?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPharmacistUpdatable
   */
  readonly __typename?: string;
}

export function PharmacyPharmacistUpdatableFromJSON(json: any): PharmacyPharmacistUpdatable {
  return PharmacyPharmacistUpdatableFromJSONTyped(json, false);
}

export function PharmacyPharmacistUpdatableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyPharmacistUpdatable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPharmacistUpdatableTypename,

    firstName: !exists(json, "first_name") ? undefined : json["first_name"],
    lastName: !exists(json, "last_name") ? undefined : json["last_name"],
  };
}

export function PharmacyPharmacistUpdatableToJSON(object?: PharmacyPharmacistUpdatable | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    first_name: value.firstName,
    last_name: value.lastName,
  };
}
